module.exports = __webpack_public_path__ + "static/media/img_warn.e350a4b5.svg";